import React from 'react';
import { WithQueryClient } from '../../common/WithQueryClient';
import { BackofficeContent } from './BackofficeContent';
import { JsonPropsType } from '../../../component-loader';
import { DocumentTypeOption } from './types';

interface ContractSigningBackofficeWrapperProps {
  isSuperuser: boolean;
  isReadonly: boolean;
  documentTypes: DocumentTypeOption[];
}

export function ContractSigningBackofficeWrapper(props: JsonPropsType) {
  const { isSuperuser, isReadonly, documentTypes } = (
    props.jsonObject as ContractSigningBackofficeWrapperProps
  );
  return (
    <WithQueryClient>
      <BackofficeContent
        isSuperuser={isSuperuser}
        isReadOnly={isReadonly}
        documentTypes={documentTypes}
      />
    </WithQueryClient>
  );
}
